/**
 * Payment gateway config (platform admin) — enable/disable + fees.
 * Talks to /api/payment-gateways.
 */
import ApiService from './api.service';

const unwrap = (res) => (res && res.data ? res.data.data : null);

const PaymentGatewayService = {
  list: async () => unwrap(await ApiService.get('/api/payment-gateways')) || [],
  listEnabled: async () => unwrap(await ApiService.get('/api/payment-gateways/enabled')) || [],
  create: async (data) => unwrap(await ApiService.post('/api/payment-gateways', data)),
  update: async (id, data) => unwrap(await ApiService.put(`/api/payment-gateways/${id}`, data)),
  toggle: async (id) => unwrap(await ApiService.put(`/api/payment-gateways/${id}/toggle-status`, {})),
  remove: async (id) => ApiService.delete(`/api/payment-gateways/${id}`),
};

export default PaymentGatewayService;
